import { Event } from "../Event";

export class InfringementControlFkGroupErrorIdEvents extends Event {
    // public onChange = (value: any, setField: any, setState: any, formValues: any) => {
    //     this.setState("loadings", ["infringement_control_fk_error_id", "infringement_control_value"])

    //     if (value) {
    //         this.setField("infringement_control_fk_error_id", {
    //             readonly: false
    //         })

    //         this.setFieldValue("infringement_control_fk_error_id", undefined)

    //         this.setField("infringement_control_fk_error_id", {
    //             width: 6
    //         })

    //         this.setField("infringement_control_value", {
    //             hidden: true,
    //             required: false
    //         })

    //         this.setFieldValue("infringement_control_value", 0)
    //     } else {
    //         this.setField("infringement_control_fk_error_id", {
    //             readonly: true,
    //             width: 6
    //         })

    //         this.setFieldValue("infringement_control_fk_error_id", undefined)

    //         this.setField("infringement_control_value", {
    //             hidden: true,
    //             required: false
    //         })

    //         this.setFieldValue("infringement_control_value", 0)
    //     }

    //     setTimeout(() => {
    //         this.setState("loadings", [])
    //     }, 100)
    // }
}